import { Pipe, PipeTransform, NgModule } from '@angular/core';
import * as moment from 'moment';
import { Moment } from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../services/shared.service';
import { languageEnum } from '../enum-files/languageEnum';

@Pipe({ name: 'timeformat' })
export class TimeFormatPipe implements PipeTransform {
  public currentLang;
  constructor(private translate: TranslateService,
    private sharedService: SharedService){
  }

  transform(value, fromFormat, toFormat): any {
    if(this.sharedService.isExternal){
      if(this.sharedService.externalLang == languageEnum.Dutch){
        this.currentLang = "nl-NL";
      } if(this.sharedService.externalLang == languageEnum.English){
        this.currentLang = 'en-US';
      }else if(this.sharedService.externalLang == languageEnum.Polish){
        this.currentLang = 'pl-PL';
      }else if(this.sharedService.externalLang == languageEnum.German){
        this.currentLang = 'de-DE';
      }
    }else{
    this.currentLang = localStorage.getItem("language")
    }
    if (!value) return value;
    if(fromFormat == 'date'){
      return moment(value).format(toFormat);
    }else if(fromFormat == 'js_date'){
      if(this.currentLang == 'en-US'){
        return moment(value).format(toFormat)
      }else if(this.currentLang == 'nl-NL'){
        return moment(value).locale('nl').format(toFormat)
      }else if(this.currentLang == 'pl-PL'){
        return moment(value).locale('pl').format(toFormat)
      }else if(this.currentLang == 'de-DE'){
        return moment(value).locale('de').format(toFormat)
      }else {
        return moment(value).format(toFormat)
      }
    }
    else{
      return moment(value, fromFormat).format(toFormat);
    }
  
  }
}

@Pipe({
  name: 'filterUser',
  pure: false
})

export class FilterUserPipe implements PipeTransform {
  tagBool:boolean = false
  transform(value: any,
    filterString: string) {
      
    if (!value) return true;
    if (value.length === 0 || !filterString) {
      return value;
    }
    const filterArray = [];
    for (let item of value) {
      
      if(filterString){
        filterString = filterString.replace(new RegExp("\\\\", "g"), "\\\\");
      }
      if(filterString == "*"){
        filterString = ""
      }
      var regEx = new RegExp(filterString, 'ig')
      if(item.CalendarName.match(regEx)){
        this.tagBool = true;
      }
      if(this.tagBool){
        filterArray.push(item);
        this.tagBool = false;
      }
    }
    return filterArray;
  }
}

@Pipe({
  name: 'filterOffice',
  pure: false
})

export class FilterOfficePipe implements PipeTransform {

  transform(value: any,
    filterString: string) {
      
    if (!value) return true;
    if (value.length === 0 || filterString === '') {
      return value;
    }
    const filterArray = [];
    for (let item of value) {
      if(!item['name']){
        item['name'] = ''
      }
      if(filterString){
        filterString = filterString.replace(new RegExp("\\\\", "g"), "\\\\");
      }
      if(filterString == "*"){
        filterString = ""
      }
      var regEx = new RegExp(filterString, 'ig')
      if (item['name'].match(regEx)) {
        filterArray.push(item);
      }
    }
    return filterArray;
  }

}

@Pipe({
  name: 'filterRecruiter',
  pure: false
})

export class FilterRecruiterPipe implements PipeTransform {

  transform(value: any,
    filterString: string) {
      
    if (!value) return true;
    if (value.length === 0 || filterString === '') {
      return value;
    }
    const filterArray = [];
    for (let item of value) {
      // if(!item['name']){
      //   item['name'] = ''
      // }
      if(filterString){
        filterString = filterString.replace(new RegExp("\\\\", "g"), "\\\\");
      }
      if(filterString == "*"){
        filterString = ""
      }
      var regEx = new RegExp(filterString, 'ig')
      if(item){
        var name;
        if(item.FirstName || item.LastName){
        name = item.FirstName + ' ' + item.LastName
        }else{
        name = item.Email
        }
      if(name && name.match(regEx)){
        filterArray.push(item);
      }
    }
      // if (item['name'].match(regEx)) {
      //   filterArray.push(item);
      // }
    }
    return filterArray;
  }

}

@Pipe({
  name: 'hrsAndMin',
  pure: false
})
export class HrsAndMinPipe implements PipeTransform {
  transform(value: any) {
    return moment(value).format("HH:mm");
  }
}

@Pipe({
  name: 'filterOfficeCalender',
  pure: false
})

export class FilterOfficeInCalenderPipe implements PipeTransform {

  transform(value: any,
    filterString: string) {
      
    if (!value) return true;
    if (value.length === 0 || filterString === '') {
      return value;
    }
    const filterArray = [];
    for (let item of value) {
      if(!item['label']){
        item['label'] = ''
      }
      if(filterString){
        filterString = filterString.replace(new RegExp("\\\\", "g"), "\\\\");
      }
      if(filterString == "*"){
        filterString = ""
      }
      var regEx = new RegExp(filterString, 'ig')
      if (item['label'].match(regEx)) {
        filterArray.push(item);
      }
    }
    return filterArray;
  }

}


@NgModule({
  imports: [
    // dep modules
  ],
  declarations: [ 
    TimeFormatPipe,
    FilterUserPipe,
    FilterOfficePipe,
    FilterRecruiterPipe,
    HrsAndMinPipe,
    FilterOfficeInCalenderPipe
  ],
  exports: [
    TimeFormatPipe,
    FilterUserPipe,
    FilterOfficePipe,
    FilterRecruiterPipe,
    HrsAndMinPipe,
    FilterOfficeInCalenderPipe
  ]
})
export class ApplicationPipes {}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/TimeFormatPipe.ts